export const getAdvice = state => state.advice.adviceList;
export const getAdviceDetails = state => state.advice.adviceDetails;
